import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  IconButton,
  Input,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import CTable from "../../../components/Table/table";
import {
  deleteAttendenceRequest,
  listAttendenceForStudentRequest,
} from "../../../modules/admin-modules/attendence/Actions";

const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
};

const studentName = (record) =>
  record?.student?.name || record?.user?.name || record?.name || "—";

const lectureTitle = (record) =>
  record?.lecture?.title || record?.lecture_title || "—";

const attendanceStatus = (record) => {
  if (record?.attend == null || record?.attend === "") return "—";
  return Number(record.attend) === 1 || record.attend === true ? "حاضر" : "غائب";
};

const StudentAttendanceReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cancelRef = useRef();
  const user = useSelector((state) => state.user.userData);
  const isUserLoading = useSelector((state) => state.user.isLoading);
  const records = useSelector((state) => state.attendence.records);
  const isLoading = useSelector((state) => state.attendence.isLoading);
  const [name, setName] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    if (isUserLoading) return;
    if (user?.role && Array.isArray(user.role)) {
      const isSuperAdmin = user.role[0]?.name === "Super Admin";
      if (!isSuperAdmin) {
        navigate("/dashboard/students");
      }
    }
  }, [user, isUserLoading, navigate]);

  useEffect(() => {
    setPageNumber(0);
  }, [records]);

  if (isUserLoading || !user?.role) {
    return null;
  }

  const isSuperAdmin =
    user?.role &&
    Array.isArray(user.role) &&
    user.role[0]?.name === "Super Admin";
  if (!isSuperAdmin) {
    return null;
  }

  const handleSearch = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      toast.error("اكتب اسم الطالب");
      return;
    }
    setHasSearched(true);
    dispatch(listAttendenceForStudentRequest(trimmed));
  };

  const openDeleteConfirm = (record) => {
    setRecordToDelete(record);
  };

  const closeDeleteConfirm = () => {
    if (isLoading) return;
    setRecordToDelete(null);
  };

  const confirmDelete = () => {
    if (!recordToDelete?.id) return;
    dispatch(
      deleteAttendenceRequest(recordToDelete.id, () => {
        setRecordToDelete(null);
      })
    );
  };

  const Data = (records || []).map((record) => ({
    ...record,
    id: record?.id,
    student_name: studentName(record),
    lecture: lectureTitle(record),
    status: attendanceStatus(record),
    date: formatDate(record?.actual_time || record?.created_at),
    parent_comment: record?.parent_comment || "—",
    delete: (
      <IconButton
        variant="outline"
        border="0"
        color="gray.600"
        aria-label="Delete attendance"
        fontSize="20px"
        icon={<RiDeleteBinLine color="red" />}
        onClick={(event) => {
          event.stopPropagation();
          openDeleteConfirm(record);
        }}
      />
    ),
  }));

  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "الطالب", accessor: "student_name" },
    { Header: "المحاضرة", accessor: "lecture" },
    { Header: "الحالة", accessor: "status" },
    { Header: "التاريخ", accessor: "date" },
    { Header: "تعليق ولي الأمر", accessor: "parent_comment" },
    { Header: "حذف", accessor: "delete" },
  ];

  return (
    <Layout>
      <Flex
        w="100%"
        my="30px"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={3}
      >
        <Text fontSize="24px" fontWeight="600" color="main_1">
          Student Attendance
        </Text>
        <LogoutMenu />
      </Flex>

      <Flex
        w="100%"
        mb="20px"
        gap={3}
        alignItems="center"
        flexWrap="wrap"
      >
        <Input
          maxW="360px"
          bg="#f5f5f5"
          borderRadius="16px"
          placeholder="اسم الطالب"
          value={name}
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") handleSearch();
          }}
        />
        <Button bg="main_1" color="white" onClick={handleSearch}>
          بحث
        </Button>
      </Flex>

      {!hasSearched ? (
        <Text color="gray.600" mb="20px">
          ابحث باسم الطالب لعرض سجل الحضور
        </Text>
      ) : null}

      <CTable
        selectedData={() => {}}
        Columns={columns}
        Data={hasSearched ? Data : []}
        path={"openModel"}
        Actions
        Title=""
        subTitle=""
        btnTitle=""
        placeHolder=""
        noSearchBar={true}
        noFilter={true}
        footerBtnTitle
        filterList
        addButton
        addButtonTitle=""
        setPage={setPage}
        setPerPage={setPerPage}
        currentpage={pageNumber}
        setPageNumber={setPageNumber}
        noSecondSearchBar={true}
        isLoading={isLoading}
        perPage={size}
        totalPage={Math.ceil((hasSearched ? records?.length || 0 : 0) / size)}
      />

      <AlertDialog
        isOpen={Boolean(recordToDelete)}
        leastDestructiveRef={cancelRef}
        onClose={closeDeleteConfirm}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              حذف سجل الحضور
            </AlertDialogHeader>
            <AlertDialogBody>
              هل أنت متأكد من حذف سجل حضور{" "}
              {recordToDelete ? studentName(recordToDelete) : ""}
              {recordToDelete ? ` — ${lectureTitle(recordToDelete)}` : ""}؟
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeDeleteConfirm}>
                إلغاء
              </Button>
              <Button
                bg="red.500"
                color="white"
                _hover={{ bg: "red.600" }}
                onClick={confirmDelete}
                isLoading={isLoading}
                ml={3}
              >
                حذف
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Layout>
  );
};

export default StudentAttendanceReport;
